// extracted by mini-css-extract-plugin
module.exports = {"section":"_1R3Os"};